import React from "react";
import { Header, Subsection, FooterLinks, DataPageContainer } from "../components";
import data from "../data/coop_data.json";
import info from "../data/coop_info.json";
import { getContent } from "./Helper";

function Coop() {
  return (
    <DataPageContainer>
      <Header>Co-op</Header>
      <Subsection> 
        CAD is the currency used in all monetary analysis. For co-op salaries, 
        we used the approximate historical 5-year average USD/CAD exchange rate 
        (1 USD = 1.3 CAD). 
      </Subsection>
      {getContent(info, data)}
      <FooterLinks
        back={{ text: "view school data", to: "school" }}
        next={{ text: "view lifestyle data", to: "lifestyle" }}
      />
    </DataPageContainer>
  );
}

export default Coop;
